import Session from "../auth/Session";

const InstrumentFunctions = {
    postQuoteRequestUploadAsync: async function (fileData) {
        const token = Session.getToken();
        const response = await fetch(`api/Calibration/UploadQuoteRequestFile`, {
            method: "POST",
            body: fileData,
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });
        const data = await response.json();
        return data;
    },
    postAssetChangeRequestAsync: async function (formData) {
        const token = Session.getToken();
        const response = await fetch(`api/calibration/assetchangerequest`, {
            method: "POST",
            body: JSON.stringify(formData),
            headers: !token ? {} : { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' }
        });
        const data = await response.json();
        return data;
    },
    postExistingQuoteRequestAsync: async function (formData) {
        const token = Session.getToken();
        const response = await fetch(`api/Calibration/ExistingQuoteRequest`, {
            method: "POST",
            body: JSON.stringify(formData),
            headers: !token ? {} : { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' }
        });
        const data = await response.json();
        return data;
    },
    postExistingPackingListAsync: async function (formData) {
        const token = Session.getToken();
        const response = await fetch(`api/Calibration/ExistingQuoteRequest`, {
            method: "POST",
            body: JSON.stringify(formData),
            headers: !token ? {} : { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' }
        });
        const data = await response.json();
        return data;
    },
    postNewQuoteRequestAsync: async function (formData) {
        const token = Session.getToken();
        const response = await fetch(`api/Calibration/NewQuoteRequest`, {
            method: "POST",
            body: JSON.stringify(formData),
            headers: !token ? {} : { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' }
        });
        const data = await response.json();
        return data;
    },
    postNewPackingListAsync: async function (formData) {
        const token = Session.getToken();
        const response = await fetch(`api/Calibration/NewPackingList`, {
            method: "POST",
            body: JSON.stringify(formData),
            headers: !token ? {} : { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' }
        });
        const data = await response.json();
        return data;
    },
    postOnSiteScheduleUploadAsync: async function (fileData) {
        const token = Session.getToken();
        const response = await fetch(`api/Calibration/UploadOnSiteScheduleFile`, {
            method: "POST",
            body: fileData,
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });
        const data = await response.json();
        return data;
    },
    postInstrumentListUploadAsync: async function (fileData) {
        const token = Session.getToken();
        const response = await fetch(`api/Calibration/UploadInstrumentList`, {
            method: "POST",
            body: fileData,
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });
        const data = await response.json();
        return data;
    }
}

export default InstrumentFunctions;